<style scoped>
.settings-wrapper {
  padding: 24px;
}
.select-control-row{
  padding: 8px 0;
}
.select-control-group {
  margin: 16px 0;
}
</style>

<template>
  <mu-container>
    <mu-paper :z-depth="1" class="settings-wrapper" v-if="fetchedSettings && ready">
      <h1>{{$t('theme.title')}}</h1>
      <mu-row>
        <mu-col>
          <mu-flex class="select-control-row" v-for="mode in optionsThemeMode">
            <mu-radio :value="mode" v-model="themeMode" :label="$t('theme.mode.' + mode)" />
          </mu-flex>
        </mu-col>
        <mu-col>
          <mu-flex class="select-control-row" v-for="color in optionsThemeColor">
            <mu-radio :value="color" v-model="themeColor" :label="$t('theme.color.' + color)" />
          </mu-flex>
        </mu-col>
      </mu-row>
      <div v-if="themeColor === 'custom'">
        <mu-expansion-panel>
          <div slot="header"><mu-icon value="stop" :color="primary" class="vertical-align-bottom"/> {{$t('theme.custom.primary')}}</div>
          <color-picker v-model="primary"/>
        </mu-expansion-panel>
        <mu-expansion-panel>
          <div slot="header"><mu-icon value="stop" :color="secondary" class="vertical-align-bottom"/> {{$t('theme.custom.secondary')}}</div>
          <color-picker v-model="secondary"/>
        </mu-expansion-panel>
        <mu-expansion-panel>
          <div slot="header"><mu-icon value="stop" :color="success" class="vertical-align-bottom"/> {{$t('theme.custom.success')}}</div>
          <color-picker v-model="success"/>
        </mu-expansion-panel>
        <mu-expansion-panel>
          <div slot="header"><mu-icon value="stop" :color="warning" class="vertical-align-bottom"/> {{$t('theme.custom.warning')}}</div>
          <color-picker v-model="warning"/>
        </mu-expansion-panel>
        <mu-expansion-panel>
          <div slot="header"><mu-icon value="stop" :color="info" class="vertical-align-bottom"/> {{$t('theme.custom.info')}}</div>
          <color-picker v-model="info"/>
        </mu-expansion-panel>
        <mu-expansion-panel>
          <div slot="header"><mu-icon value="stop" :color="error" class="vertical-align-bottom"/> {{$t('theme.custom.error')}}</div>
          <color-picker v-model="error"/>
        </mu-expansion-panel>
        <mu-expansion-panel>
          <div slot="header"><mu-icon value="stop" :color="track" class="vertical-align-bottom"/> {{$t('theme.custom.track')}}</div>
          <color-picker v-model="track"/>
        </mu-expansion-panel>
      </div>
    </mu-paper>
  </mu-container>
</template>

<script>

// Library
import MuseUI from 'muse-ui'
import axios from "axios";

import { Chrome } from 'vue-color'

import defaultCustom from '@/themes/default.js'

export default {
  name: 'ThemePage',
  components: {
    'color-picker': Chrome
  },
  data() {
    return {
      ready: false,
      theme: "",
      custom: {},
      
      optionsThemeMode: ['light', 'dark'],
      optionsThemeColor: ['default', 'red', 'blue', 'green', 'carbon', 'custom'],
      
      timeout: null,
    }
  },
  created() {

  },
  computed: {
    fetchedSettings() {
      return this.$store.state.flag.fetchedSettings;
    },
    themeMode:{
      get() {
        var split = this.theme.split('-');
        return split[1];
      },
      set(newValue) {
        this.theme = this.themeColor + '-' + newValue; 
        if(newValue === 'custom') {
          this.onCreateCustomTheme();
        }
        this.onChangeTheme(this.themeColor + '-' + newValue);
      }
    },
    themeColor:{
      get() {
        var split = this.theme.split('-');
        return split[0];
      },
      set(newValue) {
        this.theme = newValue + '-' + this.themeMode;
        if(newValue === 'custom') {
          this.onCreateCustomTheme();
        }
        this.onChangeTheme(newValue + '-' + this.themeMode);
      }
    },
    primary:{
      get() {
        return this.custom.primary;
      },
      set(newValue) {
        this.custom.primary = newValue.hex;
      }
    },
    secondary:{
      get() {
        return this.custom.secondary;
      },
      set(newValue) {
        this.custom.secondary = newValue.hex;
      }
    },
    success:{
      get() {
        return this.custom.success;
      },
      set(newValue) {
        this.custom.success = newValue.hex;
      }
    },
    warning:{
      get() {
        return this.custom.warning;
      },
      set(newValue) {
        this.custom.warning = newValue.hex;
      }
    },
    info:{
      get() {
        return this.custom.info;
      },
      set(newValue) {
        this.custom.info = newValue.hex;
      }
    },
    error:{
      get() {
        return this.custom.error;
      },
      set(newValue) {
        this.custom.error = newValue.hex;
      }
    },
    track:{
      get() {
        return this.custom.track;
      },
      set(newValue) {
        this.custom.track = newValue.hex;
      }
    },
  },
  watch: {
    fetchedSettings(newValue) {
      if(newValue) {
        this.theme = this.$store.state.settings.theme;
        if(this.$store.state.settings.custom) {
          this.custom = this.$store.state.settings.custom;
        } else {
          this.custom = defaultCustom;
        }
        this.ready = true;
      }
    },
    primary() {
      this.onChangeCustom();
    },
    secondary() {
      this.onChangeCustom();
    },
    warning() {
      this.onChangeCustom();
    },
    success() {
      this.onChangeCustom();
    },
    info() {
      this.onChangeCustom();
    },
    error() {
      this.onChangeCustom();
    },
    track() {
      this.onChangeCustom();
    },
  },
  mounted() {
    if(this.fetchedSettings) {
      this.theme = this.$store.state.settings.theme;
      if(this.$store.state.settings.custom) {
        this.custom = this.$store.state.settings.custom;
      } else {
        this.custom = defaultCustom;
      }
      this.ready = true;
    }
  },
  methods: {
    onChangeTheme(theme) {
      this.theme = theme;
      this.$store.dispatch('updateSettings', {
        theme: theme,
        custom: this.custom
      });
    },
    onCreateCustomTheme() {
      MuseUI.theme.add('custom-light', this.custom, 'light');
      MuseUI.theme.add('custom-dark', this.custom, 'dark');
    },
    onChangeCustom() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.onCreateCustomTheme();
        this.onChangeTheme(this.theme);
      }, 500);
    }
  }
}
</script>
